import { useLazyLoadedToolsQuery } from '#app/__generated__/relay/useLazyLoadedToolsQuery.graphql.js';
import { graphql, useLazyLoadQuery } from '@contra/relay';
import { useMemo } from 'react';

export type Tool = {
  __typename: 'Tool';
  id: string;
  logoImage: null | {
    uid: string;
  };
  name: string;
};

export const useLazyLoadedTools = ({
  limitFetchedPopularTools = 3,
  skipFetchPopularTools = true,
}: {
  readonly limitFetchedPopularTools?: number;
  readonly skipFetchPopularTools?: boolean;
}): {
  popularToolsForUser: Tool[];
  suggestedTools: Tool[];
} => {
  const {
    popularToolsForUser: popularToolsForUserQueryResult,
    suggestedTools: suggestedToolsQueryResult,
  } = useLazyLoadQuery<useLazyLoadedToolsQuery>(
    graphql`
      query useLazyLoadedToolsQuery(
        $skipFetchPopularTools: Boolean!
        $limitFetchedPopularTools: Int!
      ) {
        suggestedTools {
          edges {
            node {
              __typename
              id
              name
              logoImage {
                uid
              }
            }
          }
        }

        popularToolsForUser(limit: $limitFetchedPopularTools)
          @skip(if: $skipFetchPopularTools) {
          id
          name
          logoImage {
            uid
          }
          __typename
        }
      }
    `,
    {
      limitFetchedPopularTools,
      skipFetchPopularTools,
    },
  );

  const suggestedTools = useMemo(() => {
    return suggestedToolsQueryResult.edges.map(({ node }) => node);
  }, [suggestedToolsQueryResult]);

  const popularToolsForUser = useMemo(() => {
    return (
      popularToolsForUserQueryResult?.map(
        ({ __typename, id, logoImage, name }) => ({
          __typename,
          id,
          logoImage,
          name,
        }),
      ) ?? []
    );
  }, [popularToolsForUserQueryResult]);

  return {
    popularToolsForUser,
    suggestedTools,
  };
};
